import type {
    RibbonTabDefinitionBase,
    RibbonTabDefinitionSet,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import getMLRFormatTab from 'owa-mail-ribbon/lib/components/MLR/mlr-format-tab/getMLRFormatTab';
import getMLRMessageTab from 'owa-mail-ribbon/lib/components/MLR/mlr-message-tab/getMLRMessageTab';
import getMLRInsertTab from 'owa-mail-ribbon/lib/components/MLR/mlr-insert-tab/getMLRInsertTab';
import getContextualMlrTabsDefinition from 'owa-mail-ribbon/lib/components/MLR/ContextualTabs/getContextualMlrTabsDefinition';

export const getMailComposeProjectionDefinitionMLR = (
    props: RibbonControlDefinitionProps
): RibbonTabDefinitionSet => {
    const mlrTabs: RibbonTabDefinitionBase[] = [getMLRMessageTab(props)];

    if (isFeatureEnabled('cmp-ribbonInsertTab')) {
        mlrTabs.push(getMLRInsertTab(props));
    }

    mlrTabs.push(getMLRFormatTab(props));

    mlrTabs.push(...getContextualMlrTabsDefinition(props));

    return {
        tabs: mlrTabs,
    };
};
